import { call, getContext, put, takeEvery } from "redux-saga/effects";

import {
  reportCreatorSuccess,
  reportCreatorFailure,
  reportPostSuccess,
  reportPostFailure,
} from "./actions";
import { reportCreatorActionTypes, reportPostActionTypes } from "./actionTypes";
import { CONTEXT } from "@const/redux";

const reportCreatorAsync = ({ UsersService, id, report }) => {
  if (!UsersService) {
    console.log("Required services does not exist");

    return null;
  }

  return UsersService.reportCreatorById(id, report);
};

function* reportCreator({ payload }) {
  try {
    const { id, report } = payload;

    const { UsersService } = yield getContext(CONTEXT.SERVICES);
    yield call(reportCreatorAsync, { UsersService, id, report });

    yield put(reportCreatorSuccess());
  } catch ({ error }) {
    yield put(reportCreatorFailure({ error }));
  }
}

const reportPostAsync = ({ PostsService, id, report }) => {
  if (!PostsService) {
    console.log("Required services does not exist");

    return null;
  }

  return PostsService.reportPostById(id, report);
};

function* reportPost({ payload }) {
  try {
    const { id, report } = payload;

    const { PostsService } = yield getContext(CONTEXT.SERVICES);
    yield call(reportPostAsync, { PostsService, id, report });

    yield put(reportPostSuccess());
  } catch ({ error }) {
    yield put(reportPostFailure({ error }));
  }
}

export function* watchReportCreator() {
  yield takeEvery(reportCreatorActionTypes.request, reportCreator);
}

export function* watchReportPost() {
  yield takeEvery(reportPostActionTypes.request, reportPost);
}
